import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin, MapPin, Mail, Phone, ArrowRight } from "lucide-react";
import { CLINIC } from "../mock";
import { subscribeNewsletter } from "../api";
import Logo from "./Logo";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await subscribeNewsletter(email);
    } catch (err) {
      console.error("Newsletter subscribe failed:", err);
      // still confirm to user; subscription is non-critical in the footer
    }
    setDone(true);
    setEmail("");
    setTimeout(() => setDone(false), 3500);
  };

  return (
    <footer className="bg-charcoal text-cream relative overflow-hidden">
      <div className="max-w-[1300px] mx-auto px-6 pt-20 pb-10">
        <div className="grid md:grid-cols-4 gap-12 pb-14 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-5"><Logo size="md" className="!items-start" /></div>
            <p className="text-cream/60 text-sm leading-relaxed font-sans">
              A high-end medical spa &amp; hair restoration clinic in the heart of Edmonton&rsquo;s Brewery District, dedicated to natural, refined and lasting beauty.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href={CLINIC.socials.instagram} target="_blank" rel="noreferrer" className="text-cream/60 hover:text-gold transition-colors"><Instagram size={18} strokeWidth={1.5} /></a>
              <a href={CLINIC.socials.facebook} target="_blank" rel="noreferrer" className="text-cream/60 hover:text-gold transition-colors"><Facebook size={18} strokeWidth={1.5} /></a>
              <a href={CLINIC.socials.youtube} target="_blank" rel="noreferrer" className="text-cream/60 hover:text-gold transition-colors"><Youtube size={18} strokeWidth={1.5} /></a>
              <a href={CLINIC.socials.linkedin} target="_blank" rel="noreferrer" className="text-cream/60 hover:text-gold transition-colors"><Linkedin size={18} strokeWidth={1.5} /></a>
            </div>
          </div>

          {/* Explore */}
          <div>
            <h4 className="eyebrow text-gold mb-6">Explore</h4>
            <ul className="space-y-3 font-sans text-sm">
              {[["Home","/"],["About Us","/about"],["Treatments","/services"],["Hair Clinic","/hair-clinic"],["Results","/results"],["Book Now","/booking"],["Contact","/contact"]].map(([l,t]) => (
                <li key={t}><Link to={t} className="text-cream/70 hover:text-gold transition-colors">{l}</Link></li>
              ))}
            </ul>
          </div>

          {/* Visit */}
          <div>
            <h4 className="eyebrow text-gold mb-6">Visit Us</h4>
            <ul className="space-y-4 font-sans text-sm text-cream/70">
              <li className="flex gap-3"><MapPin size={16} strokeWidth={1.5} className="text-gold shrink-0 mt-0.5" /><span>{CLINIC.address}</span></li>
              <li className="flex gap-3"><Mail size={16} strokeWidth={1.5} className="text-gold shrink-0 mt-0.5" /><a href={`mailto:${CLINIC.email}`} className="hover:text-gold">{CLINIC.email}</a></li>
              <li className="flex gap-3"><Phone size={16} strokeWidth={1.5} className="text-gold shrink-0 mt-0.5" /><a href={`tel:${CLINIC.phone}`} className="hover:text-gold">{CLINIC.phone}</a></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="eyebrow text-gold mb-6">Join The Club</h4>
            <p className="text-cream/60 text-sm font-sans mb-4">Exclusive offers &amp; skincare rituals, delivered.</p>
            <form onSubmit={submit} className="relative">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="w-full bg-transparent border-b border-white/25 py-3 pr-10 text-sm text-cream placeholder:text-cream/40 focus:outline-none focus:border-gold transition-colors font-sans"
              />
              <button type="submit" className="absolute right-0 top-1/2 -translate-y-1/2 text-gold hover:translate-x-1 transition-transform">
                <ArrowRight size={18} />
              </button>
            </form>
            {done && <p className="text-gold text-xs mt-3 font-sans tracking-wide">Thank you for subscribing.</p>}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8 text-cream/40 text-xs font-sans tracking-wide">
          <p>© {new Date().getFullYear()} Aesthetix MD · Qualitas Care Clinic. All rights reserved.</p>
          <p>Cosmetic · Medical · Wellness</p>
        </div>
      </div>
    </footer>
  );
}
